<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showGoal"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <div
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full"
        >
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Goal Name One</p>
            <img
              v-if="!loading"
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <div class="grid grid-cols-3 p-4 gap-5">
            <div class="flex text-sm items-center gap-3">
              <p class="font-bold">Goal Name</p>
              <p>Gaol Name Here</p>
            </div>
            <div class="flex text-sm items-center gap-3">
              <p class="font-bold">Goal Measure</p>
              <p>Goal Measure Here</p>
            </div>
            <div class="flex text-sm items-center gap-3">
              <p class="font-bold">Goal Target</p>
              <p>Gaol Target Here</p>
            </div>
            <div class="flex text-sm items-center gap-3">
              <p class="font-bold">Start Date</p>
              <p>Start Date</p>
            </div>
            <div class="flex text-sm items-center gap-3">
              <p class="font-bold">End Date</p>
              <p>End Date</p>
            </div>
          </div>
          <div class="p-4 text-sm">
            <label class="pb-1 font-bold">Description</label>
            <p>
              Lem ipsum dolor sit amet, consectetur adipiscing elit. Nam
              hendrerit nisi sed sollicitudin pellentesque. Nunc posuere purus
              rhoncus pulvinar aliquam. Ut aliquet tristique nisl vitae volutpat
            </p>
          </div>
          <div class="m-4 bg-gray-100 rounded-md">
            <div class="border-b-1.5 p-2">
              <p class="text-sm">Employee Review</p>
            </div>
            <div class="grid grid-cols-3 p-4 gap-5">
              <div class="flex text-sm items-center gap-3">
                <p class="font-bold">Acheived Target</p>
                <p>15,000</p>
              </div>
              <div class="flex text-sm items-center gap-3">
                <p class="font-bold">Employee Rating</p>
                <p>95%</p>
              </div>
              <div class="flex text-sm items-center gap-3">
                <p class="font-bold">Employee Attachment</p>
                <p class="cursor-pointer">&#128206;</p>
              </div>
              <div class="flex text-sm items-center gap-3">
                <p class="font-bold">Start Date</p>
                <p>Start Date</p>
              </div>
              <div class="flex text-sm items-center gap-3">
                <p class="font-bold">End Date</p>
                <p>End Date</p>
              </div>
            </div>
            <div class="p-4 text-sm">
              <label class="pb-1 font-bold">Description</label>
              <p>
                Lem ipsum dolor sit amet, consectetur adipiscing elit. Nam
                hendrerit nisi sed sollicitudin pellentesque. Nunc posuere purus
                rhoncus pulvinar aliquam. Ut aliquet tristique nisl vitae
                volutpat
              </p>
            </div>
          </div>
          <div class="m-4 bg-gray-100 rounded-md">
            <div class="border-b-1.5 p-2">
              <p class="text-sm">My Review</p>
            </div>
            <div class="grid grid-cols-3 gap-5 p-4">
              <div class="text-sm">
                <label class="block pb-1">Acheived Target</label>
                <input
                  type="text"
                  class="p-2 bg-white rounded-full w-full"
                  placeholder="15,000"
                />
              </div>
              <div class="text-sm">
                <label class="block pb-1">My Rating</label>
                <input
                  type="text"
                  class="p-2 bg-white rounded-full w-full"
                  placeholder="98%"
                />
              </div>
              <div class="text-sm">
                <label class="block pb-1">Attachment</label>
                <input
                  type="text"
                  class="p-2 bg-white rounded-full w-full"
                  placeholder="View"
                />
              </div>
            </div>
            <div class="p-4 text-sm">
              <label class="pb-1">Description</label>
              <textarea
                class="p-1 bg-white rounded-xl w-full"
                cols="5"
              ></textarea>
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "ManagerReviewOneGoal",
  props: ["showGoal"],
  data() {
    return {
      selectedType: "single",
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
